import { ApplePayPrime } from '../../../types/ApplePayPrimeResponse';
import * as navigationService from '../../../utils/navigationService';

export default {
  onPaid(_transactionID: number, _data: ApplePayPrime): void {
    const currentScreen =
      navigationService.screenSubject$.getValue()?.currentScreen;
    const { routeName, params } = currentScreen || {};

    navigationService.replace(routeName, params);
  },
};
